import { SHOW_PUSH_NOTIFICATION_MODAL } from './types';

// eslint-disable-next-line import/prefer-default-export
export const setShowPushNotificationModal = (isOpen = false) => ({
  type: SHOW_PUSH_NOTIFICATION_MODAL,
  payload: { isOpen },
});
